import { env, analytics, bridge } from './index';
import { objectToQuery } from '@mx/util/object-to-query';
import { analyticConfig } from '@/config/analyticConfig';

export function bindCard() {
  const params = {
    merchant_no: env.merchantNo,
    callback_type: 'close_webview',
    ext_dim_stat_entry: env.extDimStatEntry
  };
  const url = `${location.origin}/portal/bindcard/bindcard.html?${objectToQuery(params)}`;
  bridge.openPage(url);
  analytics.setName('pay');
  analytics.pv(analyticConfig.bindCard.cid);
  analytics.click(analyticConfig.bindCard.bid, {
    custom: {
      merchant_no: env.merchantNo,
      ext_dim_stat_entry: env.extDimStatEntry
    }
  });
  analytics.setName(env.appName);
  const bindTime = Date.now().toString();
  bridge.setStorage('pay-bindcard-open-time', bindTime);
}
